/**
 * Walk a DataTransfer (including nested folders via webkitGetAsEntry) and
 * return File objects with webkitRelativePath set for directory drops.
 */
export const collectDroppedFiles = async (
  dataTransfer: DataTransfer,
): Promise<File[]> => {
  const items = dataTransfer.items;
  if (items?.length) {
    const files: File[] = [];

    const readEntries = (entry: FileSystemEntry, pathPrefix: string): Promise<void> => {
      return new Promise((resolve) => {
        if (entry.isFile) {
          (entry as FileSystemFileEntry).file(
            (f) => {
              Object.defineProperty(f, "webkitRelativePath", {
                value: pathPrefix + f.name,
                writable: false,
              });
              files.push(f);
              resolve();
            },
            () => resolve(),
          );
        } else if (entry.isDirectory) {
          const reader = (entry as FileSystemDirectoryEntry).createReader();
          reader.readEntries(async (entries) => {
            await Promise.all(
              entries.map((child) =>
                readEntries(child, pathPrefix + entry.name + "/"),
              ),
            );
            resolve();
          }, () => resolve());
        } else {
          resolve();
        }
      });
    };

    const promises: Promise<void>[] = [];
    for (let i = 0; i < items.length; i++) {
      const entry = items[i].webkitGetAsEntry?.();
      if (entry) promises.push(readEntries(entry, ""));
    }
    await Promise.all(promises);

    if (files.length > 0) return files;
  }

  return dataTransfer.files?.length ? Array.from(dataTransfer.files) : [];
};
